import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig, UrlModule, I18nModule } from 'haba-core';

import { CheckoutProgressComponent } from './checkout-progress/checkout-progress.component';
import { CheckoutHeaderComponent } from './checkout-header.component';

import { CartNotEmptyGuard } from 'haba-featurelibs/checkout/components';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    NgbTooltipModule,
    CheckoutHeaderComponent,
    CheckoutProgressComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutHeaderComponent: {
          component: CheckoutHeaderComponent,
          disableSSR: true,
        },
        CheckoutProgress: {
          component: CheckoutProgressComponent,
          guards: [CartNotEmptyGuard],
          disableSSR: true,
        },
      },
    }),
  ],
  exports: [CheckoutHeaderComponent],
})
export class CheckoutHeaderModule {}
